<table mat-table
       matSort
       [dataSource]="dataSource"
       multiTemplateDataRows
       class="mat-elevation-z8 expandable-table"
	   (matSortChange)="updateSort.emit($event)"
>
    <ng-container [matColumnDef]="column.id" *ngFor="let column of template.settings?.activeColumns; let i = index; trackBy: trackByFn">
        <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                [disabled]="!!column.disableSort"
                [resizeColumn]="true"
                [index]="i"
                [style.width]="column.width ? column.width + 'px' : '150px'"
                [style.min-width]="scrollableTable && (column.width ? column.width + 'px' : '150px')"
        >
            {{ column.name }}
        </th>
        <ng-container [ngSwitch]="column.type">
            <!-- Date -->
            <ng-container *ngSwitchCase="'date'">
                <td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element">
                    {{ resolveDotNotationPath(column.path, element) | date }}
                </td>
            </ng-container>

            <!-- User -->
            <ng-container *ngSwitchCase="'user'">
                <td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element">
                    <ng-container *localVar="resolveDotNotationPath(column.path, element) as user">
                        {{ user?.nameFirst }} {{ user?.nameLast }}
                    </ng-container>
                </td>
            </ng-container>

            <!-- Badge -->
            <ng-container *ngSwitchCase="'badge'">
                <td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element">
                    <ng-container *localVar="resolveDotNotationPath(column.path, element) as badge">
                        <span class="tags-list" *ngIf="badge">
                            <mat-basic-chip  disableRipple class="tag-item" color="primary">
                                {{ badge.name }}
                            </mat-basic-chip>
                        </span>
                    </ng-container>
                </td>
            </ng-container>

            <!-- Badges -->
            <ng-container *ngSwitchCase="'badges'">
                <td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element">
                    <ng-container *localVar="column.valueFn(element).split(',') as items">
                        <span class="tags-list" *ngIf="items?.length">
                            <ng-container *ngFor="let item of items">
                                <ng-container *ngIf="item !== ''">
                                     <mat-basic-chip class="tag-item" color="primary">
                                        {{ item }}
                                    </mat-basic-chip>
                                </ng-container>
                            </ng-container>
                        </span>
                    </ng-container>
                </td>
            </ng-container>

            <!-- Custom function-->
            <ng-container *ngSwitchCase="'icon'">
                <td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element" [class.pointer]="column.linked" (click)="linkEvent(column, element)">
                    <a [attr.href]="column.linked?.href ?? null">
                        <mat-icon inline>
                            {{column.valueFn(element)}}
                        </mat-icon>
                    </a>
                </td>
            </ng-container>

            <!-- Custom function-->
            <ng-container *ngSwitchCase="'custom'">
                <td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element" [class.pointer]="column.linked" (click)="linkEvent(column, element)">
                    <a [attr.href]="column.linked?.href ?? null" [innerHtml]="column.valueFn(element)"> </a>
                </td>
            </ng-container>

			<!-- Custom function-->
			<ng-container *ngSwitchCase="'icon'">
				<td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element"
					[class.pointer]="column.linked"
					(click)="linkEvent(column, element)">
					<a [attr.href]="column.linked?.href ?? null">
						<mat-icon>{{column.valueFn(element)}}</mat-icon>
					</a>
				</td>
			</ng-container>

			<!-- Custom function-->
            <ng-container *ngSwitchCase="'accordion'">
                <td [class.colored]="expandedElement === element"
					mat-cell *matCellDef="let element" [class.pointer]="column.linked" (click)="linkEvent(column, element)">
                    <a [attr.href]="column.linked?.href ?? null" [innerHtml]="column.valueFn(element)"> </a>
                </td>
            </ng-container>

            <!-- Default -->
            <ng-container *ngSwitchDefault>
                <ng-container *ngIf="column?.extra?.allowHoverDetail">
                    <td [class.colored]="expandedElement === element"
                        appProjectItemThumbnailCardHover
                        [project]="element"
                        mat-cell *matCellDef="let element">
                        <a [class.pointer]="column.linked"
                           (click)="$event.preventDefault(); $event.stopPropagation(); linkEvent(column, element)"
                           [attr.href]="column.linked?.href ?? null"
                           [innerHtml]="resolveDotNotationPath(column.path, element)"> </a>
                    </td>
                </ng-container>
                <ng-container *ngIf="!column?.extra?.allowHoverDetail">
                    <td [class.colored]="expandedElement === element"
                        mat-cell *matCellDef="let element">
                        <a [class.pointer]="column.linked"
                           (click)="$event.preventDefault(); $event.stopPropagation(); linkEvent(column, element)"
                           [attr.href]="column.linked?.href ?? null"
                           [innerHtml]="resolveDotNotationPath(column.path, element)"> </a>
                    </td>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
        <td [class.colored]="expandedElement === element"
			class="expanding-component"
			[attr.colspan]="template.settings?.activeColumns?.length + 1"
			mat-cell *matCellDef="let element" (click)="onRowClick(element)">
            <div *ngFor="let expandedItem of (element[template.settings.expandableProperty] | slice : 0 : MAX_EXPANDED_ROWS)"
                 class="expandable-row"
                 [class.expanded]="element.id == expandedElement?.id"
				 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
				<ng-container  *ngIf="cardTemplate">
					<ng-container [ngTemplateOutlet]="cardTemplate"
                                  [ngTemplateOutletContext]="{ $implicit: {expandedItem, containerElement: element} }"></ng-container>
				</ng-container>
			</div>
			<div [class.expanded]="element.id == expandedElement?.id"
				 [class.colored]="expandedElement === element"
				 class="more-items"
				 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
				 *ngIf="element?.[template.settings.expandableProperty]?.length > MAX_EXPANDED_ROWS && element.id == expandedElement?.id">
				<span (click)="openProject(element)" i18n="More Item Count Label@@collectionTableMoreItemCountLabel">
					+ {{element?.[template.settings.expandableProperty]?.length - MAX_EXPANDED_ROWS}} items
				</span>
			</div>
        </td>
    </ng-container>

    <ng-container *ngIf="template.settings.actions" matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef
			style="width: 50px; min-width: 50px"></th>
        <td [class.colored]="expandedElement === element"
			mat-cell *matCellDef="let element">
            <ng-container *ngFor="let action of template.settings.actions" class="ml-2">
                <ng-container *ngIf="!action.condition || collectionUtils.isConditionValid(action.condition, element)">
                    <button
                            *ngIf="action.id != 'create' && action.type !== ActionType.MENU"
                            class="action-button {{ action.classes }}"
                            [class.icon-left]="action.showName"
                            [class.icon-only]="!action.showName"
                            [class.active]="action.type === ActionType.SELECT && isSelected(element.id)"
                            [class.loading]="action.type === ActionType.EXPORT && isLoading(element.id)"
                            [disabled]="action.type === ActionType.EXPORT && isLoading(element.id)"
                            [matTooltip]="action.showTooltip ? action.name : undefined"
                            color="primary"
                            (click)="$event.preventDefault(); $event.stopPropagation(); onActionEvent(element, action)"
                    >
                        <ng-container *ngIf="action.type === ActionType.SELECT && isSelected(element.id); then selected; else unselected">
                        </ng-container>

                        <ng-template #unselected>
                            <ng-container *ngIf="action.type === ActionType.EXPORT && isLoading(element.id); else loaded">
                                <mat-spinner [diameter]="20"></mat-spinner>
                            </ng-container>
                            <ng-template #loaded>
                                <mat-icon inline [class.material-symbols-outlined]="action.type === ActionType.PIN && !element.isPinned">{{ action.toggleOptions?.offIcon || action.icon }}</mat-icon>
                            </ng-template>

                            <span *ngIf="action.showName">{{ action.toggleOptions?.offName || action.name }}</span>
                        </ng-template>

                        <ng-template #selected>
                            <mat-icon inline>{{ action.toggleOptions.onIcon }}</mat-icon>
                            <span *ngIf="action.showName">{{ action.toggleOptions.onName }}</span>
                        </ng-template>
                    </button>

                    <button
                            *ngIf="action.type === ActionType.MENU"
                            class="action-button {{ action.classes }}"
                            [class.icon-left]="action.showName"
                            [class.icon-only]="!action.showName"
                            color="primary"
							(click)="$event.preventDefault(); $event.stopPropagation();"
                            [matTooltip]="action.showTooltip ? action.name : undefined"
                            [matMenuTriggerFor]="menuAction"
                    >
                        <mat-icon inline *ngIf="action.icon">{{ action.icon }}</mat-icon>
                        <span *ngIf="action.showName">{{ action.name }}</span>

                        <mat-menu #menuAction="matMenu" class="tiny">
                            <div *ngFor="let menuAction of action.actionSettings" mat-menu-item [ngClass]="menuAction.classes" (click)="onActionEvent(element, menuAction)">
                                <mat-icon *ngIf="menuAction.icon">{{ menuAction.icon }}</mat-icon> <span>{{ menuAction.name }}</span>
                            </div>
                        </mat-menu>
                    </button>
                </ng-container>
            </ng-container>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="activeColumnIds"></tr>
    <tr mat-row *matRowDef="let element; columns: activeColumnIds;"
        class="example-element-row"
        (click)="onRowClick(element)">
    </tr>
    <ng-container>
        <tr mat-row
			*matRowDef="let row; columns: ['expandedDetail']"
            class="example-detail-row" (click)="onRowClick(row)">
        </tr>
    </ng-container>

    <tr class="no-data mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9999">
            <div class="get-started-container">
                <div class="content-container">
                    <h2 class="title" i18n="No Data Message@@collectionTableNoDataMessageTitle">We couldn't find any data for this filter set.</h2>
                    <p class="description" i18n="No Data Message@@collectionTableNoDataMessageDescription">Try broadening your search or reset your filters below.</p>

                    <div class="actions">
                        <!-- <button mat-flat-button class="button-extra-small" color="primary" (click)="resetFilters.emit()">
                            Reset Filters
                        </button> -->
                    </div>
                </div>
            </div>
        </td>
    </tr>
</table>


<!-- TODO: IMPROVE BUTTONS -->
<div class="table-footer" [class.show-scrollbar]="scrollableTable">
    <div *ngIf="showCreateButton()" class="buttons-container">
        <button mat-flat-button color="primary" (click)="onActionEvent(null, showCreateButton())">
            <i class="uil-plus"></i>
            <ng-container i18n="Create New Button@@collectionTableCreateNewButton">Create new</ng-container>
        </button>
    </div>
    <mat-paginator
            [pageIndex]="page - 1"
            [pageSize]="limit"
            [length]="totalResults"
            [pageSizeOptions]="limitOptions"
            (page)="updatePagination.emit($event)"
    ></mat-paginator>
</div>
